export const BIG_QUERY_GROUP_HEADER_CLICKS = 'header_clicks';
